<div class="container-fluid py-4">
  <div class="d-flex justify-content-between align-items-center gap-2 mb-4">
    <div>
      <h2 class="mb-1"><i class="fas fa-exchange-alt text-primary"></i> Perfil bancario</h2>
      <p class="text-muted mb-0">Con qué contrato bancario nacen los pagos de los botones y del Débito Inmediato</p>
    </div>
    <div class="d-flex gap-2">
      <button type="button" class="btn btn-outline-secondary" [disabled]="perfilLoading" (click)="loadPerfilBancario()">
        <i class="fas fa-sync-alt" [class.fa-spin]="perfilLoading"></i> Verificar
      </button>
      <a routerLink="/console/async-admin" class="btn btn-outline-primary"><i class="fas fa-arrow-left"></i> Pagos Asíncronos</a>
    </div>
  </div>

  <div *ngIf="!_auth.hasPermission('config.perfil_bancario.read')" class="alert alert-secondary">
    No tiene permiso para ver el perfil bancario.
  </div>

  <div data-rbac-permiso="config.perfil_bancario.read" *ngIf="_auth.hasPermission('config.perfil_bancario.read')" class="mb-3">
    <div class="kb-tabs">
      <button type="button" class="kb-tab" [ngClass]="{'kb-tab-activo': pestana === 'switch'}" (click)="pestana = 'switch'">Contrato activo</button>
      <button type="button" class="kb-tab" [ngClass]="{'kb-tab-activo': pestana === 'cuentas'}" (click)="pestana = 'cuentas'">Cuentas por contrato</button>
    </div>
  </div>

  <div data-rbac-permiso="config.perfil_bancario.read" *ngIf="_auth.hasPermission('config.perfil_bancario.read')" class="row mb-4" [hidden]="pestana !== 'switch'">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div *ngIf="perfilError" class="alert alert-danger mb-3">
            <i class="fas fa-exclamation-triangle me-2"></i>{{ perfilError }}
          </div>

          <div *ngIf="perfilBancario" class="row">
            <div class="col-md-5 mb-3">
              <div class="p-3 border rounded">
                <div class="text-muted small">Perfil activo</div>
                <div class="perfil-activo">{{ perfilBancario.activo }}</div>
                <div class="text-muted small" *ngIf="perfilBancario.desde">desde {{ perfilBancario.desde | date:'dd/MM/yyyy HH:mm' }}</div>
                <p class="small text-muted mt-2 mb-0">
                  Con este contrato nacen las transacciones nuevas del Botón BDV, del Botón Mercantil y del Débito Inmediato.
                  Pago móvil y transferencia se verifican según la cuenta que recibió el pago.
                </p>
              </div>
            </div>
          </div>

          <!-- Historial -->
          <div *ngIf="perfilBancario?.historia?.length" class="mt-2">
            <h6 class="fw-bold">Historial</h6>
            <div class="table-responsive">
              <table class="table table-sm align-middle mb-0">
                <thead>
                  <tr><th>Fecha</th><th>Cambio</th><th>Resultado</th><th>Usuario</th><th>Motivo</th></tr>
                </thead>
                <tbody>
                  <tr *ngFor="let h of perfilBancario.historia">
                    <td>{{ h.fecha | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td>{{ h.de }} → {{ h.a }}</td>
                    <td><span class="badge" [ngClass]="h.resultado === 'APLICADO' ? 'bg-success' : 'bg-secondary'">{{ h.resultado === 'APLICADO' ? 'Aplicado' : 'Rechazado' }}</span></td>
                    <td>{{ h.usuario?.username || '—' }}</td>
                    <td>{{ h.motivo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Cuentas por contrato: la vista de dos niveles (opciones de pago y sus cuentas), con borrador, bloqueos, guardado e historial -->
  <div data-rbac-permiso="config.perfil_bancario.read" *ngIf="_auth.hasPermission('config.perfil_bancario.read') && pestana === 'cuentas'" id="cuentas-por-contrato" class="mb-4">
    <app-cuentas-contrato></app-cuentas-contrato>
  </div>
</div>
